import availability from '../product/tickets-form/availability';

$(function() {
    let form;
    
    $(document).on('click', '.js-field-dropdown__field_btn', function showOptions() {
        const $wrapBtn = $(this).closest('.js-field-dropdown__label')
        const $openingBlock = $($wrapBtn)
            .siblings('.js-field-dropdown__hidden');
        const $productsWrap = $(this).closest('.js-products-wrap');

        if ($($productsWrap).length) {
            const elPosition = $(this).offset();
            const productsWrapPosition = $($productsWrap).offset();

            $($openingBlock).css({
                top: elPosition.top - productsWrapPosition.top - $wrapBtn.outerHeight(),
                left: elPosition.left - productsWrapPosition.left - 10,
            });
        }
        
        if (!$($wrapBtn).hasClass('is-open')) {
            if($wrapBtn.hasClass('js-field-dropdown__tickets')) {
                var $seatmapTabButton = $('button[data-target=seatmap]');
                if($seatmapTabButton.length > 0 && $(window).width() >= 1180) {
                    $seatmapTabButton.trigger('click');
                }
            }
        }

        if ($($wrapBtn).hasClass('is-open')) {
            let elementToCheck = $('div').is($('.js-field-dropdown__label-for-availability').closest('.sidebar-top__wrap'))
                ? $('.js-field-dropdown__label-for-availability').closest('.sidebar-top__wrap')
                : form;

            availability.checkAvailability(elementToCheck);

            return $([$wrapBtn, $openingBlock]).toggleClass('is-open');
        }

        $('.js-field-dropdown__label, .js-field-dropdown__hidden')
            .removeClass('is-open');

        $([$wrapBtn, $openingBlock]).toggleClass('is-open');

        if ($(window).width() > 767) return;

        $('html, body').animate({
            scrollTop: $($wrapBtn).offset().top
                - $('.js-header').outerHeight()
                - $($wrapBtn).outerHeight(),
            duration: 2000
        });
    });

    $(document).click( function closeBlocks(e) {
        form = $('.js-field-dropdown__label.is-open').closest('.js-product-order');

        const optionsBtnCheck = $(e.target)
            .closest('.js-field-dropdown__field_btn').length;
        const optionsWrapCheck = $(e.target)
            .closest('.js-field-dropdown__label').length;
        const optionsCheck = $(e.target)
            .closest('.js-field-dropdown__hidden').length;
        const addTicketsBtn = $(e.target).hasClass('js-tickets-add');

        let isOpened = $('.js-field-dropdown__label').hasClass('is-open');

        if (!isOpened || optionsBtnCheck || optionsWrapCheck || optionsCheck && !addTicketsBtn) return;

        let elementToCheck = $('div').is($('.js-field-dropdown__label-for-availability').closest('.sidebar-top__wrap'))
            ? $('.js-field-dropdown__label-for-availability').closest('.sidebar-top__wrap')
            : form;

        availability.checkAvailability(elementToCheck);

        $('.js-field-dropdown__label, .js-field-dropdown__hidden')
            .removeClass('is-open');
    });

    $(document).on('click', '.js-field-dropdown__option', function() {
        const chosenName = $(this).find('p').text();
        const $wrap = $(this).closest('.js-field-dropdown__hidden')
        const $target = $($wrap).siblings('.js-field-dropdown__label');
        const errorBlock = $($target).find('.label__error');

        $($target).find('input[type="button"]').val(chosenName);
        $($target).removeClass('has-error');

        $($wrap).removeClass('is-open');
        $($target).removeClass('is-open');
        $($target).addClass('has-value');

        if (errorBlock.length <= 1) return $(errorBlock).remove();

        for (let i = 0; i < errorBlock.length; i++) {
            $(errorBlock[i]).remove();
        }

    });

    $('.sidebar-top__products').on('scroll', function moveDropdowns(e) {
        if (!$('.js-field-dropdown__hidden.is-open').length) return;

        availability.checkAvailability(
            $('div').is($('.js-field-dropdown__label-for-availability')
                .closest('.sidebar-top__wrap'))
            ? $('.js-field-dropdown__label-for-availability')
                .closest('.sidebar-top__wrap')
            : form);

        $('.js-field-dropdown__label, .js-field-dropdown__hidden')
            .removeClass('is-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/field-dropdown.js